module.exports = __webpack_public_path__ + "static/media/angel_dice.c402c6b6.png";